const PRINT_AGENT_URL = 'http://127.0.0.1:9199/print';
const HEALTH_URL = 'http://127.0.0.1:9199/health';

/**
 * Print ticket via local ESC/POS agent (Windows kiosk). Returns true on success.
 */
export async function printViaAgent({ ticket, orgName, ticketTemplate }) {
  const res = await fetch(PRINT_AGENT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ticket,
      org_name: orgName,
      ticket_template: ticketTemplate,
    }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Print agent error (${res.status})`);
  }
  return true;
}

export async function isPrintAgentAvailable() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 800);
  try {
    const res = await fetch(HEALTH_URL, { method: 'GET', signal: controller.signal });
    if (!res.ok) return false;
    const data = await res.json();
    return data.ok === true;
  } catch {
    return false;
  } finally {
    clearTimeout(timer);
  }
}
